import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Experience } from "@/components/Experience";
import { Design } from "@/components/Design";
import { VideoSection } from "@/components/VideoSection";
import { Vision } from "@/components/Vision";
import { Signup } from "@/components/Signup";
import { Partner } from "@/components/Partner";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/scroll";
import { usePageMeta } from "@/lib/meta";

export default function LandingPage() {
  usePageMeta({
    title: "Peanut Valet | Hand-Crank Peanut Sheller in Development",
    description: "Meet Peanut Valet, a full-size hand-crank peanut sheller in development. Explore the design, watch the concept video, and get development and launch updates.",
    canonical: "https://peanutvalet.com/",
    ogTitle: "Meet Peanut Valet — A New Twist on Snack Time",
    ogDescription: "Explore the Peanut Valet vision and follow the journey toward bringing this hand-crank peanut sheller to market.",
    ogImage: "https://peanutvalet.com/assets/peanut-valet-social-share.png",
  });
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash), 450);
      return () => clearTimeout(t);
    }
  }, [hash]);

  return (
    <div data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Experience />
        <Design />
        <VideoSection />
        <Vision />
        <Signup />
        <Partner />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
